module.exports = "/images/menu.svg?510fa92bb53297b856ed3152fc0f190f";